import * as React from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';

export const BlockView = (Component) => {

	class BlockView extends React.Component {

        constructor(props, context) {
            super(props, context);
    
            this.state = {
                active: false
            }
        }

		componentWillMount () {
            this.checkIfPhone();
        }

        componentWillReceiveProps (nextProps) {
            this.checkIfPhone();
        }
		
		checkIfPhone () {
			if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                this.setState({active: false});
            }else {
                this.setState({active: true});
            }
		}

		render() {
			const { active } = this.state;
            return (
                <div>
                    {active
                        ? <Component {...this.props}/>
                        : (
                            <div className="hero" style={{marginTop: "25vh"}}>
                                <div className="hero-body">
                                    <h2 className="has-text-centered">För bästa upplevelse av ritverktyget ber vi er att använda desktop versionen.</h2>
                                </div>
                            </div>
                        )
                    }
                </div>
            );
        }
	}

	const mapStateToProps = (state) => {
		return {}
	};
	const mapDispatchToProps = (dispatch) => {
	return {
		
	};
};
	return connect(mapStateToProps, mapDispatchToProps)(BlockView);
};


// WEBPACK FOOTER //
// ./src/Utils/BlockView/index.js